import styled from 'styled-components';

import {colors} from 'theme';

export const AttachmentsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`;

export const AttachmentsLabel = styled.div`
    color: ${colors.darkGrey};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.32px;
    line-height: 24px;
    text-transform: uppercase;
`;

export const AttachmentsContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
`;

export const AttachmentDropzone = styled.div<{isDragActive: boolean}>`
    box-sizing: border-box;
    display: flex;
    flex: 1 1 320px;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 120px;
    max-height: 120px;
    padding: 20px;
    border: 1px dashed
        ${({isDragActive}) => (isDragActive ? colors.brandPrimary : colors.textMuted)};
    border-radius: 8px;
    background-color: ${({isDragActive}) => (isDragActive ? colors.brandLight : colors.white)};
    cursor: pointer;
    outline: none;
    transition: border-color 200ms ease, background-color 200ms ease;

    &:hover,
    &:focus-visible {
        border-color: ${colors.brandPrimary};
        background-color: ${colors.brandLight};
    }
`;

export const AttachmentDropzoneContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
`;

export const AttachmentDropzoneText = styled.p`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 14px;
`;

export const AttachmentDropzoneAction = styled.span`
    color: ${colors.brandPrimary};
    font-weight: 600;
`;

export const AttachmentDropzoneHint = styled.span`
    color: ${colors.textSecondary};
    font-size: 12px;
`;

export const AttachmentFilesColumn = styled.div`
    display: flex;
    flex: 1 1 320px;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
`;

export const AttachmentFilesCount = styled.div`
    color: ${colors.textPrimary};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.24px;
    line-height: 16px;
    text-transform: uppercase;
`;

export const AttachmentFileList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const AttachmentFileItem = styled.li`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border: 1px solid ${colors.border};
    border-radius: 8px;
    background-color: ${colors.white};
`;

export const AttachmentFileIcon = styled.span<{background: string}>`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background-color: ${({background}) => background};
    color: ${colors.white};
    font-size: 10px;
    font-weight: 700;
    line-height: 15px;
    text-transform: uppercase;
`;

export const AttachmentFileMeta = styled.div`
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
`;

export const AttachmentFileName = styled.span`
    overflow: hidden;
    color: ${colors.darkGrey};
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const AttachmentFileSize = styled.span`
    color: ${colors.textSecondary};
    font-size: 12px;
    line-height: 16px;
`;
